<template>
  <div>
    <b-row>
      <b-col xl="3" lg="5">
        <report-settings
          class="mb-3"
          @report-requested="getNewReport()"
          :settings="query"
          :my-auctions="myAuctions"
          @myauctions-changed="myAuctions = !myAuctions"></report-settings>
      </b-col>
      <b-col class="overflow-auto">
        <div v-if="reportRequested">
          <template v-if="!reportBlank">
            <report-graphs
              class="mb-3"
              :report="report"
              :stats="reportStats"
              :fields="reportFields"
              :timezone="reportTimeZone"
              :currently-viewed-report="currentlyViewedReport"
              :nodata="reportBlank"
              :interval="reportInterval"
              @color-update="colorUpdate">
            </report-graphs>
            <report-table-card
              ref="tableCard"
              @page-change="pageChanged"
              :collapsible="true"
              :exportable="true"
              :report="report"
              :stats="reportStats"
              :fields="reportFields"
              :interval="reportInterval"
              :timezone="reportTimeZone"
              :graph-colors="graphColors"
              :synced-with-graph="true"
              :nodata="reportBlank">
            </report-table-card>
          </template>
          <template v-else>
            <no-results class="mt-md-5"></no-results>
          </template>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>

  .sidebar {
    width: 400px;
  }

  .vue-affix {
    width: 400px !important;
  }

  .scrollable {
    overflow-y: scroll;
    max-height: 100vh;
    margin-right: -25px;
    padding-right: 25px;
  }

  .scrollable::-webkit-scrollbar {
    display: none;
  }

  #reportContent {
    position: relative;
  }
</style>

<script>
    import auth from '@/auth'
    import ReportSettings from '@/reports/pages/Explorer/ReportSettings'
    import ReportGraphs from '@/reports/pages/Explorer/ReportGraphs'
    import ReportTableCard from '@/reports/components/ReportTableCard'
    import NoResults from '@/components/NoResults'

    import moment from 'moment'
    import {ReportsApi} from '@/reports/api'
    import _ from 'lodash'

    export default {
        props: {
            cid: {required: false, type: String}
        },
        data() {
            return {
                query: {
                    fields: [],
                    stats: [],
                    filters: [],
                    date: {
                        start: moment().utc().startOf('day').valueOf(),
                        end: moment().utc().startOf('day').valueOf()
                    },
                    interval: '',
                    timezone: 'UTC',
                    dateAsMillis: true
                },
                report: [],
                reportStats: [],
                reportFields: [],
                reportInterval: '',
                reportTimeZone: '',
                currentlyViewedReport: [],
                graphColors: {},
                reportRequested: false,
                reportReturned: false,
                myAuctions: true
            }
        },
        created() {
            /*
             * If there are queries in the url, we apply them and
             * immediately run the report
             * Doesn't work for interval! check watchers in ReportSettings
             * if you need to do that
             */
            let queryHasReportOptions = false
            if ('settings' in this.$route.query) {
                let settings = JSON.parse(this.$route.query.settings)
                for (let option in settings) {
                    if (option in this.query) {
                        this.query[option] = settings[option]
                        queryHasReportOptions = true
                    }
                }
            }

            if (queryHasReportOptions) {
                this.getNewReport()
            }
        },
        computed: {
            //note that datepicker will (hopefully) always return dates in UTC
            //so if the user selected a different timezone, we address that here
            parsedQuery() {
                //get deep copy
                let query = JSON.parse(JSON.stringify(this.query))
                if (!('startTime' in query)) {
                    query.startTime = query.date.start
                }
                if (!('endTime' in query)) {
                    query.endTime = query.date.end
                }
                delete query.date
                //get rid of extra interval at front of fields list
                if (query.fields[0] === 'date') {
                    query.fields.shift()
                    //make sure that request by date are NOT limited
                    query.limit = 100000
                } else {
                    delete query.interval
                }
                //add user filters for if admin gets a link
                if (this.publisherId !== undefined) {
                    query.filters.push({field: 'pub_id', operator: 'EQUAL', value: String(this.publisherId)})
                }
                if (this.partnerId !== undefined) {
                    query.filters.push({field: 'partner_id', operator: 'EQUAL', value: String(this.partnerId)})
                }

                console.log(query)

                 const flatFilterMap = query.filters.reduce((keyMap, filter) => {
                   const fieldTypeKey = filter.field + ':' + filter.operator
                    const en = keyMap[fieldTypeKey]
                    if (!en) {
                      keyMap[fieldTypeKey] = filter
                    } else if (Array.isArray(en.value)) {
                     // already have multiple filter vals for field and have converted to an array
                     en.value.push(filter.value)
                   } else {
                      //if here then have multiple filter values for same field and comparator
                      en.value = [en.value, filter.value]
                    }

                    return keyMap
                }, {})

              query.filters = Object.values(flatFilterMap)

                return query
            },
            nestedReport() {
                let nested = {}
                nested = this.nest(Array.from(this.report), this.reportFields, this.reportStats)

                return nested
            },
            /*an array of the report, with each element keeping track of its depth
            note that this method adds some attributes to each row of the report
            that are specifically for use in NestedTableRow
            ie, index, showing, and expanded
            */
            flatReportTree() {
                let nested = this.nestedReport
                return this.flatten(nested)
            },
            reportBlank() {
                return this.reportReturned && this.report.length === 0
            }
        },
        methods: {
            companyId() {
                return this.cid ? this.cid : auth.details().company_id
            },
            mode() {
                return this.$route.path.split("/")[1]
            },
            dateToUnixMillis(date) {
                return moment(date).format('x')
            },
            pageChanged(currentlyViewedReport) {
                this.currentlyViewedReport = currentlyViewedReport
            },
            getNewReport(event) {
                this.reportRequested = true
                this.reportReturned = false

                if (this.myAuctions) {
                    let filters = this.query.filters
                    switch (this.mode()) {
                        case 'demand':
                            filters.push({field: 'bidder_id', operator: 'EQUAL', value: this.companyId()})
                            break
                        case 'publisher':
                            filters.push({field: 'pub_id', operator: 'EQUAL', value: this.companyId()})
                            break;
                        case 'exchange':
                            filters.push({field: 'exchange_id', operator: 'EQUAL', value: this.companyId()})
                            break;
                        default:
                        // prolly admin
                    }
                }

                ReportsApi.bqreport(this.parsedQuery, this).then((data) => {
                    this.reportReturned = true
                    this.report = data.results
                    //dont let changes to settings affect displayed data
                    this.reportStats = Array.from(this.query.stats)
                    this.reportFields = Array.from(this.query.fields)
                    this.reportTimeZone = this.query.timezone
                    this.reportInterval = this.query.interval ? this.query.interval : ''
                    //reset which page of the table user was looking at
                    this.$refs.tableCard.reset();
                    this.graphColors = {}
                })
            },
            colorUpdate(colors) {
                this.graphColors = colors
            }

        },
        components: {
            ReportSettings,
            ReportGraphs,
            ReportTableCard,
            NoResults
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/pages/Explorer/Explorer.vue